const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {path: '', component: () => import('pages/IndexPage.vue'), meta: {requiresAuth: true}},
    ]
  },
  {
    path: '/',
    component: () => import('layouts/ConnectionLayout.vue'),
    children: [
      {path: 'login', component: () => import('pages/Login.vue'), meta: {requiresAuth: false}}
    ]
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
    meta: {requiresAuth: true}
  }
]

export default routes
